var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',{on:{"click":function($event){return _vm.clear()}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"material-icons"},[_vm._v("person")]),_c('p',[_vm._v("Logout")])])
}]

export { render, staticRenderFns }